import { defineComponent } from 'vue';
export default defineComponent({
    name: 'product-description-entry-bewertungen',
    data() {
        return {
            expanded: true,
        };
    },
    methods: {
        toggleExpansion() {
            this.expanded = !this.expanded;
        },
    },
});
